<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="LabelReleases"
                :alvqa="alvqa"
                cols="2"
            /> 
            
            <ImportButton                 
                :items="importOptions"
                context="FileImport"
                :alvqa="alvqa"
                cols="2"
            />    
            
            <v-col 
                align-self="center"
                cols="4"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="LabelReleases" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'" />
            </v-col>
            <v-spacer /> 
            <v-col 
                cols="2"
                align-self="center"
            >
                <BaseButton 
                    label="lang_GENERIC_CAPTION_EXPORT"
                    @click="exportLabelReleases"
                    block
                    :alvqa="alvqa + '-list-button-export-all'"
                />
            </v-col>
            <v-col 
                cols="2"
                align-self="center"
            >
                <BaseButton 
                    label="lang_LABEL_RELEASES_BUTTON_CAPTION_NEW_RELEASE"
                    :to="{ name: editForm, params: { alvId: 'new' } }"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col> 
        </v-row>
    </div>

</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import ImportButton from '@/components/_buttons/ImportButton'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "ReleasesTopSlot",
    data() {
        return {
            editForm: "LabelReleasesEdit",
            alvqa: "label-releases"
        }
    },
    components: {
        ImportButton,
        BaseButton,
        ActionDropdown,
        BaseHeaderStats
    },
    computed: {
        importOptions() {
			return [
                {
                    text: this.$t('lang_LABEL_RELEASES_BUTTON_OPTION_HARVEST_MEDIA'), 
                    value: 'harvestMedia', 
                    alvqa: this.alvqa + '-list-import-dropdown-harvest-media'
                },	
				{
                    text: this.$t('lang_GENERAL_CAPTION_IMPORT_EXCEL'), 
                    value: 'alvExcelTemplateLabelReleases', 
                    alvqa: this.alvqa + '-list-import-dropdown-excel-template'
                },	
				{
                    text: this.$t('lang_LABEL_RELEASES_BUTTON_OPTION_ZIP_IMPORT'), 
                    value: 'alvZipLabelReleases', 
                    alvqa: this.alvqa + '-list-import-dropdown-zip' 
                },	
                {
                    text: this.$t('lang_ACCOUNT_MAPPINGS'),
                    value: 'mappingImport',
                    alvqa: this.alvqa + '-list-import-dropdown-mapping-import'
                }
			]
        },
        actions() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_EXPORT'), 
                    value: 'export',
                    alvqa: this.alvqa + '-list-action-dropdown-export'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_DELIVER_RELEASE'), 
                    value: 'prepareReleaseForDelivery',
                    alvqa: this.alvqa + '-list-action-dropdown-deliver-release',
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_COPY_WITH_TRACKS'), 
                    value: 'copyWithTracks',
                    alvqa: this.alvqa + '-list-action-dropdown-copy-with-tracks'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_COPY_WITHOUT_TRACKS'), 
                    value: 'copyWithoutTracks',
                    alvqa: this.alvqa + '-list-action-dropdown-copy-without-tracks'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_TEST_CALCULATION'), 
                    value: 'testRelease',
                    alvqa: this.alvqa + '-list-action-dropdown-test'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_LABELCOPY_EXCEL'), 
                    value: 'labelCopyExcel',
                    alvqa: this.alvqa + '-list-action-dropdown-labelcopy-excel'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_LABELCOPY_PDF'), 
                    value: 'labelCopyPdf',
                    alvqa: this.alvqa + '-list-action-dropdown-labelcopy-pdf'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_GVL_TRISYS'), 
                    value: 'gvlExcel',
                    alvqa: this.alvqa + '-list-action-dropdown-gvl-trisys'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'), 
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_EXPORT_DDEX_ERN'), 
                    value: 'ddexExport',
                    alvqa: this.alvqa + '-list-action-dropdown-ddex-ern-41-export'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                },
            ]
        },
    },
    methods: {
        exportLabelReleases() {
            this.$store.commit('setSelectedLabelReleases', [])
            this.$store.commit('setLabelReleasesExportAll', true)
            this.$store.commit('setShowLabelReleasesExportDialog', true)
        }
    }
}
</script>